<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>异动老师</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">

          <i-col :xs="12" :sm="12" :md="6">
            <Form-item label="类型">
              <Select v-model.number="queryParam.category" placeholder="全部"
                      @on-change="search" clearable>
                <Option v-for="item in teacherCategoryList"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="12" :sm="12" :md="6">
            <Form-item label="老师ID" prop="id">
              <Input name="id" v-model="queryParam.id"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="12" :sm="12" :md="6">
            <Form-item label="老师昵称">
              <Input name="name" placeholder="支持模糊搜索"
                     v-model="queryParam.name"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="12" :sm="12" :md="6">
            <Form-item label="学导：">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser"
                                 v-model="queryParam.studyConsultantId"></admin-user-select>
            </Form-item>
          </i-col>
          <i-col :xs="12" :sm="12" :md="14">
            <Form-item label="离职时间:">
              <i-col :xs="12" :sm="12" :md="6">
                <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                             @on-change="linkTimeStartChange"
                             :value="queryParam.linkStartTimeDate" style="width: 100%;"></Date-picker>
              </i-col>
              <Col span="1" style="text-align: center">
                -
              </Col>
              <i-col :xs="12" :sm="12" :md="6">
                <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                             @on-change="linkTimeEndChange"
                             :value="queryParam.linkEndTimeDate" style="width: 100%;"></Date-picker>
              </i-col>
            </Form-item>
          </i-col>
        </Row>
      </Form>

      <div class="button-container">

        <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                @click="search">搜索
        </Button>

      </div>


    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" :reloadWithPage="reloadWithPage"
          listUrl="/tch/anomaly/list"
          :params="queryParam" :onLoading="onLoading"></List>

    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId" :showStuList="true"
                    :successCallback="searchWithPage"></tch-info-modal>

    <TchCancelOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                              v-model="showTchCancelOpenedTimeModal"></TchCancelOpenedTimeModal>
  </div>
</template>
<script>
import TchCancelOpenedTimeModal from './TchCancelOpenedTimeModal.vue'
import TchAddOpenedTimeModal from './TchAddOpenedTimeModal.vue'
import TchEditOpenedTimeModal from './TchEditOpenedTimeModal.vue'
import TchCancelRandomOpenedTimeModal from './TchCancelRandomOpenedTimeModal.vue'
import TchAddRandomOpenedTimeModal from './TchAddRandomOpenedTimeModal.vue'
import TchLeaveModal from './TchLeaveModal.vue'
import TchLeaveOfficeModal from './TchLeaveOfficeModal.vue'
import TchInfoModal from './modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import EditDingDingModal from './modal/EditDingDingModal'
import TeachersDingTalkModal from './modal/TeachersDingTalkModal'
import SubstituteTchSelect from '@/components/common/SubstituteTchSelect'
import AdminUserMultSelect from '../common/AdminUserMultSelect.vue'

export default {
  components: {
    AdminUserMultSelect,
    TeachersDingTalkModal,
    EditDingDingModal,
    TchCancelOpenedTimeModal,
    TchAddOpenedTimeModal,
    TchEditOpenedTimeModal,
    TchCancelRandomOpenedTimeModal,
    TchAddRandomOpenedTimeModal,
    TchLeaveModal,
    TchLeaveOfficeModal,
    TchInfoModal,
    SubstituteTchSelect
  },
  data () {
    let $moment = this.$moment
    let $constant = this.$constant
    return {
      loadingStudents: {},
      studentDataCache: {},
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      searchLoading: false,
      rankScoreSeq: 0,
      loadingEdit: false,
      reload: 0,
      reloadWithPage: 0,
      showTchInfoModal: false,
      tchId: null,
      tchTags: [],
      tchTagPermission: false,
      queryParam: {
        studyConsultantId: '',
        isAudition: '',
        tempSchedule: '',
        sex: '',
        accent: '',
        channel: '1',
        uid: '',
        mobile: '',
        name: '',
        nickname: '',
        inviteTchName: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: -1,
        isCanBound: '',
        tchTags: [],
      },
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: [{code: 2, text: '正式老师'}, {code: 1, text: '试用期老师'}, {code: 3, text: '工作人员'}],
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showEditTagsModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      selectionTch: [],
      showSelectTch: false,
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '', // 学习导师
        adviser: '', // 课程顾问
        openedId: null,
        substituteTchId: ''
      },
      title: [
        {
          title: '老师ID',
          align: 'center',
          key: 'tchId'
        },
        {
          title: '老师昵称',
          width: 140,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let cell = renderTchNameWithScore(h, {
              text: row.firstName + row.lastName,
              score: row.monthRankScore,
              onClick: () => this.openTchInfoModal(row.tchId)
            })
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              cell,
              h('div', {slot: 'content'}, [
                this.tchTagPermission ? h('p', `${row.tchTags}`) : h('p', ''),
              ])
            ])
          }
        },
        {
          title: '异动信息',
          align: 'center',
          render: (h, params) => {
            return h('div', {
              domProps: {
                innerHTML: params.row.account
              }
            })
          }
        },
        {
          title: '详情',
          type: 'expand',
          width: 80,
          render: (h, params) => {
            const row = params.row
            // 检查缓存中是否有学生数据
            const cachedStudents = this.studentDataCache[row.tchId]
            this.loadStudentData(row.tchId, row.status === 3 ? '' : '/v2', row.tchCloseTimeId || '')
            if (cachedStudents !== undefined) {
              const students = cachedStudents || []
              if (students.length === 0) {
                return h('div', '暂无数据')
              }
              // 完整的学生信息子表格列定义
              const columns = [
                {
                  title: '学生ID',
                  width: 170,
                  key: 'uid'
                },
                {
                  title: '中(英)文名',
                  width: 170,
                  align: 'center',
                  render: (h, params) => {
                    let student = params.row
                    return h('div', [
                      h('a', {on: {click: () => this.openInfoModal(student.uid)}}, student.nickname),
                      h('p', student.enName),
                    ])
                  }
                },
                {
                  title: '上课时间',
                  width: 170,
                  render: (h, params) => {
                    let list = params.row.bookWorkLessonOpenedTimeList
                    let spanArr = []
                    if (list) {
                      list.forEach(function (element) {
                        let startTime = $moment.unix(element.startTime).utc().format(' HH:mm')
                        spanArr.push(h('span', '[' + $constant.weekZh[element.week] + startTime + ']'))
                        spanArr.push(h('br'))
                      })
                    }
                    return h('div', spanArr)
                  }
                },
                {
                  title: '学习导师',
                  width: 170,
                  key: 'studyAdviserName'
                },
              ]
              return h('Table', {
                props: {
                  columns: columns,
                  data: students,
                  size: 'small'
                },
                style: {
                  margin: '10px'
                }
              })
            } else {
              return h('div', '数据加载中...')
            }
          }
        },
        {
          title: '绑定权限',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let isCanBoundText = row.isCanBound === 1 ? '是' : '否'
            let style = row.isCanBound === 1 ? {} : {color: 'red'}
            return h('span', {style: style}, isCanBoundText)
          }
        },
        {
          title: '临时约课权限',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let isCanBoundText = row.tempSchedule === 1 ? '是' : '否'
            let style = row.isCanBound === 1 ? {} : {color: 'red'}
            return h('span', {style: style}, isCanBoundText)
          }
        },
        {
          title: '试听课权限',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let isCanBoundText = row.isAudition === 'y' ? '是' : '否'
            let style = row.isCanBound === 1 ? {} : {color: 'red'}
            return h('span', {style: style}, isCanBoundText)
          }
        },
        {
          title: '买断时间',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let isOpened = params.row.isOpened
            if (isOpened) {
              return h('a', {
                on: {
                  click: () => {
                    this.tchId = params.row.tchId
                    this.showTchCancelOpenedTimeModal = true
                  }
                }
              }, '查看')
            } else {
              return h('span', '未添加')
            }
          }
        },
        {
          title: '上课时间',
          width: 170,
          align: 'center',
          render: (h, params) => {
            let isRandomOpened = params.row.isRandomOpened
            if (isRandomOpened) {
              return h('a', {
                on: {
                  click: () => {
                    this.tchId = params.row.tchId
                    this.showCancelRandomOpenedTimeModal = true
                  }
                }
              }, '查看')
            } else {
              return h('span', '未添加')
            }
          }
        },
        {
          title: '类型',
          width: 90,
          align: 'center',
          render: (h, params) => {
            let category = params.row.category
            let categoryEnum = $constant.getEnum($constant.teacherCategory, category)
            return h('span', categoryEnum && categoryEnum.text)
          }
        },
        {
          title: '外教运营',
          key: 'studyAdviserNickname',
          width: 120,
          align: 'center',

        },
        {
          title: '授课类型',
          key: 'tchType',
          width: 100,
          align: 'center',

          render: (h, params) => {
            let tchType = params.row.tchType
            let tchTypeEnum = $constant.getEnum($constant.tchType, tchType)
            return h('span', tchTypeEnum && tchTypeEnum.text)
          }
        },
        {
          title: '来源',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let tchChannel = params.row.channel
            let tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel)
            return h('div', tchChannelEnum && tchChannelEnum.text)
          }
        },
      ]
    }
  },
  mounted: function () {
    let self = this
    let permission = self.$store.get('permissions')
    this.tchTagPermission = permission.indexOf('865') >= 0 || permission.indexOf('all') >= 0
    let queryParam = this.queryParam
    queryParam.uid = this.$route.query.uid
    this.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then(function (res) {
      if (!res || !res.data) {
        return
      }
      self.studyAdviserList = res.data
    })
  },
  created: function () {
  },
  methods: {
    loadStudentData (tchId, version, tchCloseTimeId) {
      let self = this
      // 防止重复请求
      if (self.loadingStudents[tchId]) {
        return
      }
      self.loadingStudents[tchId] = true
      // 通过 API 获取老师的学生数据
      this.$http.get(`/tch` + version + `/std-list?tchId=${tchId}&studyConsultantId=${self.queryParam.studyConsultantId}&tchCloseTimeId=${tchCloseTimeId}`).then(function (res) {
        if (res && res.data) {
          // 使用 $set 更新缓存数据
          self.$set(self.studentDataCache, tchId, res.data.data)
          // 强制更新视图
          self.$nextTick(() => {
            self.$forceUpdate()
          })
        }
      }).finally(() => {
        // 请求完成后清除加载状态
        self.loadingStudents[tchId] = false
      })
    },
    linkTimeStartChange (val) {
      this.queryParam.linkStartTimeDate = val
    },
    linkTimeEndChange (val) {
      this.queryParam.linkEndTimeDate = val
    },
    openInfoModal (val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserPayList'}
      })
      window.open(href, '_blank')
    },
    openTchInfoModal (val) {
      this.tchId = val
      this.showTchInfoModal = true
    },
    closeModal (val) {
      this.uid = null
      this.editUser = val
    },
    search () {
      this.reload = new Date().getTime()
    },
    searchWithPage () {
      this.reloadWithPage = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },
    selectionChange (selection) {
      this.selectionTch = selection
    },
  },
  watch: {}
}
</script>

<style scoped>
.margin {
  padding-left: 15px;
  margin-bottom: 10px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  align-self: flex-start;
}

.right-button {
  align-self: flex-end;
}

.spacer {
  flex: 1;
}

.bg {
  background-color: red;
}
</style>



// WEBPACK FOOTER //
// TchAnomalyList.vue?7efb1b2c